import React from 'react';
const bonusImages = ['https://cdn.magicpatterns.com/uploads/jZq9sUbCNqKaiMy9efebtu/Captura_de_pantalla_2026-04-30_a_las_6.49.53_p._m..png', 'https://cdn.magicpatterns.com/uploads/dBR7qBWcA9JbgUfMHgfuKa/Captura_de_pantalla_2026-04-30_a_las_6.50.01_p._m..png', 'https://cdn.magicpatterns.com/uploads/dcvUFQCCez5FKjk22NrSvx/Captura_de_pantalla_2026-04-30_a_las_6.50.11_p._m..png', 'https://cdn.magicpatterns.com/uploads/ep5shQkgzWi3oib1XuzFz1/Captura_de_pantalla_2026-04-30_a_las_6.50.18_p._m..png', 'https://cdn.magicpatterns.com/uploads/mcqWQjrcB1QMo2BG5YiJHD/Captura_de_pantalla_2026-04-30_a_las_6.52.08_p._m..png', 'https://cdn.magicpatterns.com/uploads/8bakPpm1YCAvgTVwAEU6jw/Captura_de_pantalla_2026-04-30_a_las_6.52.13_p._m..png', 'https://cdn.magicpatterns.com/uploads/j49o7HP6sYnvqHhcjDJbLK/Captura_de_pantalla_2026-04-30_a_las_6.52.20_p._m..png', 'https://cdn.magicpatterns.com/uploads/qMtu3vdUWMhqYgWT76hLKi/Captura_de_pantalla_2026-04-30_a_las_6.52.28_p._m..png'];
const bonuses = [{
  title: '🎁 Manual de Compras Estratégicas',
  description: <>
        Aprendé a negociar como una experta y detectá calidad al mejor precio.{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-23">
          Reducí tus costos un 30%
        </span>{' '}
        y aumentá tu margen neto directo al bolsillo.
      </>,
  oldPrice: '$39.900'
}, {
  title: '🎁 Lista Secreta de Proveedores',
  description: <>
        No pierdas tiempo buscando. Accedé a nuestra agenda de contactos
        confiables en Argentina para comprar insumos con{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-24">
          precios mayoristas reales
        </span>
        .
      </>,
  oldPrice: '$24.900'
}, {
  title: '🎁 Estrategia de Fidelización "Cliente de Oro"',
  description: <>
        Es más fácil venderle a quien ya te compró. Guiones y técnicas para que
        tus clientes se vuelvan fanáticos y te compren{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-25">
          todas las semanas del año
        </span>
        .
      </>,
  oldPrice: '$29.900'
}, {
  title: '🎁 Masterclass: Barritas Energéticas Rentables',
  description: <>
        Producto de alta rotación y margen gigante. Ideal para vender como
        "adicional" en cada pedido y{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-26">
          cubrir tus gastos fijos solo con esto
        </span>
        .
      </>,
  oldPrice: '$19.900'
}, {
  title: '🎁 Negocio de Mermeladas Gourmet',
  description: <>
        Recetas premium sin azúcar. Un producto que te diferencia, dura meses y
        podés vender en cantidad para regalería o desayunos.
      </>,
  oldPrice: '$19.900'
}, {
  title: '🎁 Postres Fit: Multiplicador de Ticket',
  description: <>
        La gente siempre quiere algo dulce. Agregá estos postres de bajo costo y
        alta percepción de valor para{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-27">
          aumentar un 30% tu facturación inmediata
        </span>
        .
      </>,
  oldPrice: '$36.000'
}, {
  title: '🎁 Recetario de Snacks para Oficina',
  description: <>
        Atacá el mercado corporativo. Snacks fáciles de transportar que se
        venden solos en oficinas y consultorios. Venta por volumen asegurada.
      </>,
  oldPrice: '$22.000'
}, {
  title: '🎁 Menús Inclusivos (Sin TACC, Vegano, Diabetes)',
  description: <>
        Diferenciate de la competencia. Captá clientes fieles que no encuentran
        opciones y están dispuestos a{' '}
        <span className="font-bold text-[#1a1a1a]" data-id="element-28">
          pagar más por comida segura y adaptada
        </span>
        .
      </>,
  oldPrice: '$47.000'
}];
export function BonusSection() {
  return <section className="w-full bg-white px-4 md:px-8 pb-20" data-id="element-29">
      <style data-id="element-30">
        {`
          @keyframes scalePulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
          .animate-scale-pulse {
            animation: scalePulse 1.5s ease-in-out infinite;
            display: inline-block;
          }
        `}
      </style>

      <div className="max-w-[900px] mx-auto" data-id="element-31">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-[42px] font-bold text-[#1a1a1a] leading-tight mb-4" data-id="element-33">
            🎁 Aceleradores de Ganancias (BONOS GRATIS HOY)
          </h2>
          <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-34"></div>
          <p className="font-['Montserrat',_sans-serif] text-[#555] text-lg md:text-xl" data-id="element-35">
            Herramientas exclusivas para{' '}
            <span className="font-bold text-[#1a1a1a]" data-id="element-36">
              aumentar tu ticket promedio
            </span>{' '}
            y diferenciarte.
          </p>
        </div>

        {/* Bonus Cards */}
        <div className="space-y-6" data-id="element-37">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white border-2 border-[#e6a817] rounded-2xl p-5 md:p-8 flex flex-col md:flex-row items-center gap-6 md:gap-8 shadow-[0_4px_20px_rgba(230,168,23,0.15)]" data-id="element-38">
              {/* Bonus Image */}
              <div className="w-full md:w-[280px] flex-shrink-0" data-id="element-39">
                {bonusImages[index] ? <img src={bonusImages[index]} alt={bonus.title} className="w-full h-auto rounded-xl object-cover" data-id="element-40" /> : <div className="w-full aspect-square bg-[#f9f8f4] rounded-xl flex items-center justify-center border border-gray-200" data-id="element-41">
                    <span className="text-gray-400 font-['Montserrat',_sans-serif] text-sm text-center px-4" data-id="element-42">
                      [Imagen pendiente]
                    </span>
                  </div>}
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left flex flex-col justify-center" data-id="element-43">
                <h3 className="font-['Montserrat',_sans-serif] font-bold text-xl md:text-2xl text-[#1a1a1a] mb-3" data-id="element-44">
                  {bonus.title}
                </h3>
                <p className="font-['Montserrat',_sans-serif] text-[#555] text-base md:text-lg leading-relaxed mb-5" data-id="element-45">
                  {bonus.description}
                </p>
                <div className="font-['Montserrat',_sans-serif] text-lg md:text-xl flex items-center justify-center md:justify-start gap-3 flex-wrap" data-id="element-46">
                  <span className="line-through text-[#c0392b] font-bold opacity-80" data-id="element-47">
                    {bonus.oldPrice}
                  </span>
                  <span className="text-[#4caf50] font-extrabold animate-scale-pulse bg-[#e8f5e2] px-3 py-1 rounded-lg" data-id="element-48">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}